export const DragBlockType = 'block';
